import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img1.png'


const _withScopeId = n => (_pushScopeId("data-v-73ff3c7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "value" }
const _hoisted_2 = { class: "value-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "value-box-box d-flex align-items-center",
    style: {"gap":"5.6rem"}
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Vision"),
    /*#__PURE__*/_createElementVNode("div")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "value-box-p" }, " We are bringing the unbanked to financial inclusion while helping thousands of SMEs to access funding for their business. ")
], -1))
const _hoisted_4 = { class: "value-list d-flex flex-column flex-md-row" }
const _hoisted_5 = { class: "d-flex align-items-start" }
const _hoisted_6 = ["xlink:href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "+40million unbanked citizens", -1))
const _hoisted_8 = { class: "d-flex align-items-start" }
const _hoisted_9 = ["xlink:href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "18 million MSMEs can’t easily access safe finance", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "value-box-box d-flex align-items-center",
    style: {"gap":"1.7rem"}
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, "How to get there"),
    /*#__PURE__*/_createElementVNode("div")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "value-p" }, " To improve the lives of underbanked people and contribute to the nation's financial growth by providing innovative solutions, products and services including noninterest loans, thrift savings, seamless transactions, financial intelligence and job opportunities. ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "img1",
    class: "w-100"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock("svg", null, [
              _createElementVNode("use", {
                "xlink:href": `${require('@/assets/icons.svg')}#icon-blue-tick`
              }, null, 8, _hoisted_6)
            ])),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createElementBlock("svg", null, [
              _createElementVNode("use", {
                "xlink:href": `${require('@/assets/icons.svg')}#icon-blue-tick`
              }, null, 8, _hoisted_9)
            ])),
            _hoisted_10
          ])
        ]),
        _hoisted_11
      ])
    ]),
    _hoisted_12
  ]))
}